import { render, staticRenderFns } from "./ContentViewToggle.vue?vue&type=template&id=27e10cf1"
import script from "./ContentViewToggle.vue?vue&type=script&lang=js"
export * from "./ContentViewToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports